import React, { useMemo } from 'react';
import { ScrollView, StyleProp, StyleSheet, Text, TouchableOpacity, View, ViewStyle } from 'react-native';
import styled from 'styled-components/native';

import { ELoginMethod } from '@webtrader/core/api/user/types';
import dynamicSize from '@webtrader/core/dynamic-size';
import { useTranslation } from '@webtrader/core/i18n';

type TabSize = 'default' | 'small' | 'xsmall';

interface ILoginSubTabProps {
  selected: ELoginMethod;
  size?: TabSize;
  setSelected: (loginMethod: ELoginMethod) => void;
}

const LoginSubTab: FCC<ILoginSubTabProps> = (props) => {
  const { selected, size = 'default', setSelected } = props;
  const { t } = useTranslation();

  const { height, fontSize } = useMemo(() => {
    switch (size) {
      case 'small':
        return {
          height: 36,
          fontSize: 12
        };
      case 'xsmall':
        return {
          height: 34,
          fontSize: 11
        };
      default:
        return {
          height: 30,
          fontSize: 13
        };
    }
  }, [size]);

  const tabStyles = useMemo(() => {
    const styles: StyleProp<ViewStyle> = {
      height
    };

    return styles;
  }, [height]);

  return (
    <StyledContainer height={height} style={tabStyles} spaceAware={true}>
      <ScrollableOptions horizontal={true} contentContainerStyle={styles.scrollableOptions}>
        <StyledTouchableOpacity
          onPress={() => setSelected(ELoginMethod.PASSWORD)}
          selected={selected === ELoginMethod.EMAIL}
        >
          <StyledText selected={selected === ELoginMethod.PASSWORD} fontSize={fontSize}>
            {t('Email')}
          </StyledText>
        </StyledTouchableOpacity>
        <StyledDivider>|</StyledDivider>
        <StyledTouchableOpacity
          onPress={() => setSelected(ELoginMethod.EMAIL)}
          selected={selected === ELoginMethod.EMAIL}
        >
          <StyledText selected={selected === ELoginMethod.EMAIL} fontSize={fontSize}>
            {t('Email OTP')}
          </StyledText>
        </StyledTouchableOpacity>
        <StyledDivider>|</StyledDivider>
        <StyledTouchableOpacity onPress={() => setSelected(ELoginMethod.SMS)} selected={selected === ELoginMethod.SMS}>
          <StyledText selected={selected === ELoginMethod.SMS} fontSize={fontSize}>
            {t('Mobile OTP')}
          </StyledText>
        </StyledTouchableOpacity>
      </ScrollableOptions>
    </StyledContainer>
  );
};

export default LoginSubTab;

const StyledContainer = styled(View)<{ height: number; spaceAware: boolean }>`
  margin-top: ${dynamicSize.convertSize(18)}px;
  height: ${({ height }) => `${dynamicSize.convertSize(height)}px`};
`;

const StyledText = styled(Text)<{ selected: boolean; fontSize: number }>`
  color: ${({ theme, selected }) => (selected ? theme.colors.primary : theme.colors.text[0])};
  font-size: ${({ fontSize }) => `${dynamicSize.convertSize(fontSize)}px`};
  font-weight: 500;
`;

const StyledTouchableOpacity = styled(TouchableOpacity)<{ selected: boolean }>`
  color: ${({ theme, selected }) => (selected ? theme.colors.primary : theme.colors.text[0])};
`;

const StyledDivider = styled(Text)`
  color: ${({ theme }) => theme.colors.text[0]};
  margin-start: ${dynamicSize.convertSize(18)}px;
  margin-end: ${dynamicSize.convertSize(18)}px;
`;

const styles = StyleSheet.create({
  scrollableOptions: {
    flexGrow: 1
  }
});

const ScrollableOptions = styled(ScrollView)``;
